import ExpandableDeductionTable from './ExpandableDeductionTable';

export default ExpandableDeductionTable;